/**
 * Loads non-critical third-party scripts after first paint to reduce TBT on homepage.
 * Analytics (GTM/GA4/Meta) initializes earlier from index.js.
 */
export function loadDeferredThirdPartyScripts() {
  const schedule =
    typeof window.requestIdleCallback === 'function'
      ? (cb) => window.requestIdleCallback(cb, { timeout: 4000 })
      : (cb) => window.setTimeout(cb, 2500);

  schedule(() => {
    // Interakt "Chat with us" widget — disabled in favour of global WhatsApp button
    // loadInteraktKiwiWidget();
  });
}

/*
 * Interakt Kiwi widget (legacy global chat)
 * -----------------------------------------
 * const KIWI_WIDGET_KEY = "9ycryN3z9W8SiCTh89zoCMRUgxeEdSdu";
 * const KIWI_SCRIPT_ID = "interakt-kiwi-sdk";
 *
 * function initKiwiWidget() { ... }
 * function loadInteraktKiwiWidget() { ... }
 */

export function loadRazorpayAffordabilityScript() {
  return loadScriptOnce('https://cdn.razorpay.com/widgets/affordability/affordability.js');
}

export function loadRazorpayCheckoutScript() {
  return loadScriptOnce('https://checkout.razorpay.com/v1/checkout.js');
}

function loadScriptOnce(src, onLoad) {
  const existing = document.querySelector(`script[data-src="${src}"]`);
  if (existing) {
    return new Promise((resolve, reject) => {
      const done = () => {
        if (onLoad) onLoad();
        resolve();
      };
      if (existing.dataset.loaded === 'true') {
        done();
        return;
      }
      existing.addEventListener('load', done, { once: true });
      existing.addEventListener('error', () => reject(new Error(`Failed to load ${src}`)), {
        once: true,
      });
    });
  }

  return new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.src = src;
    script.async = true;
    script.dataset.src = src;
    script.onload = () => {
      script.dataset.loaded = 'true';
      if (onLoad) onLoad();
      resolve();
    };
    script.onerror = () => reject(new Error(`Failed to load ${src}`));
    document.head.appendChild(script);
  });
}
